<!-- Fortschritt des Knopfes daneben. Ohne Knopfdruck (oder ohne angemeldete Anfrage) leer. -->
@if (lauf; as l) {
  @if (l.teile.length > 0) {
    <span class="ki-lauf" [class.ki-lauf--fertig]="!laeuft" role="status" aria-live="polite">
      @if (laeuft) {
        <span class="ki-lauf__ring" aria-hidden="true"></span>
      } @else {
        <span class="ki-lauf__lampe"
          [class.ki-lauf__lampe--gruen]="!fehlgeschlagen"
          [class.ki-lauf__lampe--rot]="fehlgeschlagen"
          [attr.title]="lampenTitel"
          [attr.aria-label]="fehlgeschlagen ? 'KI-Anfrage fehlgeschlagen' : 'KI-Anfrage fertig'"></span>
      }
      <span class="ki-lauf__zeit">{{ sekunden }} s</span>
      <span class="ki-lauf__texte">
        @for (teil of l.teile; track teil.id) {
          <span class="ki-lauf__text" [class.ki-lauf__text--fehler]="teil.zustand === 'fehler'"
            [attr.title]="zeile(teil)">{{ zeile(teil) }}</span>
        }
      </span>
    </span>
  }
}
